export { VpWelcomeSvg } from './VpWelcomeSvg';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpWelcomeSvg/index.js